import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  GET_PROPOSAL_TEMPLATES: createSagaAction('GET_PROPOSAL_TEMPLATES'),
  GET_PROPOSAL_TEMPLATE_SECTIONS: createSagaAction('GET_PROPOSAL_TEMPLATE_SECTIONS'),
  GET_PROPOSAL_TEMPLATE_ITEMS: createSagaAction('GET_PROPOSAL_TEMPLATE_ITEMS'),
  CLEAN_PROPOSAL_TEMPLATE_ITEMS_AND_SECTIONS: createSagaAction(
    'CLEAN_PROPOSAL_TEMPLATE_ITEMS_AND_SECTIONS'
  )
}

// Action Creators
export const actions = {
  getProposalTemplates: () => ({
    type: constants.GET_PROPOSAL_TEMPLATES.ACTION
  }),

  getProposalTemplateSections: templateId => ({
    type: constants.GET_PROPOSAL_TEMPLATE_SECTIONS.ACTION,
    templateId
  }),

  getProposalTemplateItems: templateId => ({
    type: constants.GET_PROPOSAL_TEMPLATE_ITEMS.ACTION,
    templateId
  }),

  cleanProposalTemplateItems: () => ({
    type: constants.GET_PROPOSAL_TEMPLATE_ITEMS.ACTION
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.GET_PROPOSAL_TEMPLATES.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_PROPOSAL_TEMPLATES.SUCCESS:
      return {
        ...state,
        proposalTemplates: action.payload
      }
    case constants.GET_PROPOSAL_TEMPLATE_SECTIONS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_PROPOSAL_TEMPLATE_SECTIONS.SUCCESS:
      return {
        ...state,
        proposalTemplateSections: action.payload
      }
    case constants.GET_PROPOSAL_TEMPLATE_ITEMS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_PROPOSAL_TEMPLATE_ITEMS.SUCCESS:
      return {
        ...state,
        proposalTemplateItems: action.payload
      }
    case constants.CLEAN_PROPOSAL_TEMPLATE_ITEMS_AND_SECTIONS:
      return {
        ...state,
        proposalTemplateItems: null,
        proposalTemplateSections: null,
        proposalTemplateItemsReduced: null
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/leadFunctions/proposalTemplateActions.js